var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPriceMatchGuarantee(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12,9.25c-0.41,0-0.75-0.34-0.75-0.75v-2c0-0.41,0.34-0.75,0.75-0.75s0.75,0.34,0.75,0.75v2C12.75,8.91,12.41,9.25,12,9.25z "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12,18c-0.41,0-0.75-0.34-0.75-0.75v-2c0-0.41,0.34-0.75,0.75-0.75s0.75,0.34,0.75,0.75v2C12.75,17.66,12.41,18,12,18z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.55,14.62c-0.14-0.1-0.24-0.27-0.24-0.47c0-0.32,0.26-0.57,0.58-0.57c0.17,0,0.28,0.05,0.36,0.11 c0.58,0.46,1.2,0.72,1.96,0.72c0.76,0,1.24-0.36,1.24-0.88v-0.02c0-0.5-0.28-0.77-1.58-1.07c-1.49-0.36-2.33-0.8-2.33-2.09v-0.02 c0-1.2,1-2.03,2.39-2.03c0.88,0,1.59,0.23,2.22,0.65c0.14,0.08,0.27,0.25,0.27,0.49c0,0.32-0.26,0.57-0.58,0.57 c-0.12,0-0.22-0.03-0.32-0.09c-0.54-0.35-1.06-0.53-1.61-0.53c-0.72,0-1.14,0.37-1.14,0.83v0.02c0,0.54,0.32,0.78,1.67,1.1 c1.48,0.36,2.24,0.89,2.24,2.05v0.02c0,1.31-1.03,2.09-2.5,2.09C11.23,15.5,10.33,15.2,9.55,14.62z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.95,23c-5.38,0-9.38-4.03-10.55-8.02c-0.79-2.7-0.25-5.07,0.14-6.25l0,0C2.84,4.88,6.84,1,11.98,1c0.02,0,0.03,0,0.05,0 C17.98,1.03,23,6.07,23,12c0,5.92-5.02,10.96-10.97,11C12.01,23,11.98,23,11.95,23z M11.98,2.5c-4.44,0-7.89,3.37-9.01,6.71l0,0 c-0.34,1.01-0.8,3.04-0.13,5.35c1.01,3.46,4.46,6.94,9.11,6.94c0.02,0,0.05,0,0.07,0c5.14-0.04,9.48-4.39,9.48-9.5 c0-5.12-4.34-9.48-9.47-9.5C12.01,2.5,12,2.5,11.98,2.5z M2.26,8.97L2.26,8.97L2.26,8.97z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceMatchGuarantee);
export default __webpack_public_path__ + "static/media/price_match_guarantee.722ccda4267a2baab2036533caec30bd.svg";
export { ForwardRef as ReactComponent };